import { useState, useEffect } from "react";
import { createUseStyles } from "react-jss";

import { artistService } from "services";
import { ArtistCommon, ArtistDto, ArtistRequestDto } from "dtos/shard/artist.dto";
import { UserDto } from "dtos/user.dto";

import widgets from "styles/widgets";
import { useResources } from "hooks/resources.hook";
import { useEditorActions } from "hooks/editor-actions.hook";
import { useEditorPreview } from "hooks/editor-preview.hook";
import EditorControls from "../editor-controls";

const styles = createUseStyles({
    container: {
        width: "100%",
    },
});

export default function ArtistEditor(props: {
    user?: UserDto, // Optional dto of the user.
    artist?: Partial<ArtistDto>,
    preview?: Partial<ArtistDto>,
    onPreviewUpdate?: (previewDto: Partial<ArtistDto>) => void,
    onClose?: () => void,
    onSave?:(artist: ArtistDto) => void,
}): JSX.Element
{
    // Dtos:
    const freshCommon: ArtistCommon = {
        name: props.artist?.name ?? "",
    };
    const freshRequestDto: ArtistRequestDto = {
        id: props.artist?.id,
        ...freshCommon,
    };
    const freshPreviewDto: Partial<ArtistDto> = props.preview ? structuredClone(props.preview) : props.artist ? structuredClone(props.artist) : {
        id: undefined,
        ...freshCommon,
    };

    // Hooks:
    const resources = useResources(props.user);
    const [previewDto, requestDto, previewUpdate, setRequestDto] = useEditorPreview(freshPreviewDto, freshRequestDto, props.onPreviewUpdate);
    const [onTextChange, onNumberChange, onRteChange, onCheckboxChange, onPopup] = useEditorActions(props.user, "artist", resources, requestDto, previewDto, setRequestDto, props.onPreviewUpdate);

    // Effects:
    useEffect(() => {
        setRequestDto(freshRequestDto);
    }, [props.artist]);

    // Styles:
    const widgetClasses = widgets();
    const classes = styles();

    // Artists:
    const reset = () => {
        setRequestDto(freshRequestDto);
        if (props.onPreviewUpdate) {
            props.onPreviewUpdate(props.artist ?? previewDto);
        }
    };
    
    // Return Component:
    return (
        <div className={`${widgetClasses.form} ${classes.container}`}>
            <div className={`${widgetClasses.row}`}>
                <label>Name</label>
                <input id="name" type="text" value={requestDto.name ?? ""} onChange={onTextChange} />
            </div>

            <hr/>
            <EditorControls
                editorName="artist"
                service={artistService}
                subject={props.artist}
                subjectName={props.artist?.name ?? ""}
                requestDto={requestDto}
                onSave={props.onSave}
                onReset={reset}
                onClose={props.onClose}
            />
            <hr/>
        </div>
    );
}